import React, { useState, useEffect } from 'react';
import axios from 'axios';
import URL from '../constants/ServerUrl';

const BillDetails = () => {
  const [organizationName, setOrganizationName] = useState('');
  const [contactNumber1, setContactNumber1] = useState('');
  const [contactNumber2, setContactNumber2] = useState('');
  const [address, setAddress] = useState('');
  const [panNumber, setPanNumber] = useState('');
  const [billTitle, setBillTitle] = useState('');

  const fetchBillDetails = async () => {
    try {
      const bill = await axios.get(`${URL}admin/bill`);
      setOrganizationName(bill.data.organizationName);
      setContactNumber1(bill.data.contactNumber1);
      setContactNumber2(bill.data.contactNumber2);
      setAddress(bill.data.address);
      setPanNumber(bill.data.panNumber);
      setBillTitle(bill.data.billTitle);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBillDetails();
  }, []);

  const updateBillDetails = async () => {
    try {
      const res = await axios.put(`${URL}admin/bill`, {
        organizationName,
        contactNumber1,
        contactNumber2,
        address,
        panNumber,
        billTitle,
      });

      alert('Bill details updated successfully');
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className='container mx-auto p-4 bg-white shadow rounded-lg'>

<h1 className="text-2xl font-bold text-center text-blue-600 mb-6">Edit Bill</h1>
    {/* Organization Name */}
    <div className="mb-4">
      <label htmlFor="organizationName" className="block font-semibold mb-1">Organization Name</label>
      <input
        type='text'
        id="organizationName"
        placeholder='Enter organization name'
        value={organizationName}
        onChange={(e) => setOrganizationName(e.target.value)}
        className='textInput'
      />
    </div>

    {/* Contact Number 1 */}
    <div className="mb-4">
      <label htmlFor="contactNumber1" className="block font-semibold mb-1">Contact Number 1</label>
      <input
        type='tel'
        id="contactNumber1"
        placeholder='Enter Contact Number 1'
        value={contactNumber1}
        onChange={(e) => setContactNumber1(e.target.value)}
        className='textInput'
      />
    </div>

    {/* Contact Number 2 */}
    <div className="mb-4">
      <label htmlFor="contactNumber2" className="block font-semibold mb-1">Contact Number 2</label>
      <input
        type='tel'
        id="contactNumber2"
        placeholder='Enter Contact Number 2'
        value={contactNumber2}
        onChange={(e) => setContactNumber2(e.target.value)}
        className='textInput'
      />
    </div>

    {/* Address */}
    <div className="mb-4">
      <label htmlFor="address" className="block font-semibold mb-1">Address</label>
      <input
        type='text'
        id="address"
        placeholder='Enter Address'
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        className='textInput'
      />
    </div>

    {/* PAN Number */}
    <div className="mb-4">
      <label htmlFor="panNumber" className="block font-semibold mb-1">PAN Number</label>
      <input
        type='text'
        id="panNumber"
        placeholder='Enter PAN Number'
        value={panNumber}
        onChange={(e) => setPanNumber(e.target.value)}
        className='textInput'
      />
    </div>

    {/* Bill Title */}
    <div className="mb-4">
      <label htmlFor="billTitle" className="block font-semibold mb-1">Bill Title</label>
      <input
        type='text'
        id="billTitle"
        placeholder='Enter Bill Title'
        value={billTitle}
        onChange={(e) => setBillTitle(e.target.value)}
        className='textInput'
      />
    </div>

    {/* Update button */}
    <button className='button bg-green-500 text-white rounded-md py-2 px-4' onClick={updateBillDetails}>
      Update
    </button>
  </div>
  );
};

export default BillDetails;
